
export const h = {
    case: {
        title: 'Case Information Settings',
        name: 'Name',
        coverImage: 'Cover Image',
        describe: 'Describe',
        uploadDesc: 'Click to upload the picture. The recommended size is (500 * 375)',
        shareLink: 'Share link settings',
        expiration: 'No expiration',
        on: 'On',
        off: 'Off',
        failureTime: 'Failure time',
        pickDay: 'Pick a day',
        pickerOptions: {
            shortcuts: [
                {
                    text: 'A day later',
                    value () {
                        const date = new Date();
                        date.setTime(date.getTime() + 3600 * 1000 * 24);
                        return date;
                    }
                },
                {
                    text: 'One week later',
                    value () {
                        const date = new Date();
                        date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
                        return date;
                    }
                },
                {
                    text: '30 days later',
                    value () {
                        const date = new Date();
                        date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
                        return date;
                    }
                }
            ]
        },
        dateCannotEmpty: 'Date cannot be empty',
        nameCannotEmpty: 'Name cannot be empty!',
        descCannotEmpty: 'Description cannot be empty!',
        logoSet: 'Logo settings',
        selectAll: 'Select all',
        noBrand: 'No Brand',
        openEffect: 'Opening effect',
        closeOpenMode: 'none',
        asteroidOpen: 'Asteroid opening',
        horizontalOpen: 'Opening of horizontal parade',
        asteroidCruise: 'Opening of asteroid cruise',
        Crystal: 'Crystal ball Opening',
        asteroidScale: 'Asteroid scale Opening',
        limitImage: 'The image size is too large, please limit the image size to no more than 4M',
        imageType: 'The image type is incorrect. Please upload images in PNG or JPG format',


    },
    slide: {
        case: 'Case',
        save: 'Save',
        view: 'View',
        panorama: 'Panorama',
        angleView: 'Angle of view',
        hotspot: 'Hotspot',
        music: 'Music',
        designer: 'Designer',
        beautify: 'Beautify',
    },
    list: {
        title: 'Panoramic List Settings',
        draganoramicsort: 'Drag panoramic sort',
        resetSort: 'Reset',
        addPanoramic: 'Add',
        customThumbnailImages: 'Custom thumbnail images',
        more: 'More',
        downloadImage: 'Download panoramic images',
        replaceImage: 'Replace panoramic image',
        downloadImagePackage: 'Download panoramic image package',
        downloadDiagram: 'Download channel diagram',
        ApplyThumbnailToImage: 'Apply thumbnail to the cover image',
        VoiceBroadcast: 'Voice broadcast information',
        restoreImage: 'Restore panoramic image',
        uploadImage: 'Upload image',
        upgradePackage: 'Upgrade Package',
        eidt: 'Edit',
        name: 'Name',
        thumbnail: 'Thumbnail',
        enterName: 'Enter panoramic name',
        uploadDesc: 'Click to upload the picture. The recommended size is (500 * 375)',
        confirm: 'Confirm',
        cannotEmpty: 'The panoramic name cannot be empty',
        selectToAdd: 'Select panoramic view to add',
        selectAll: 'Select all',
        StartAndEnd: 'Start and end time',
        schemeName: 'Scheme name',
        清晰度: 'Definition',
        searchThisPlan: 'Search according to this plan',
        search: 'Search',
        empty: 'Empty',
        dateOptions: {
            shortcuts: [
              {
                text: "today",
                value() {
                  const end = new Date(
                    new Date(new Date().toLocaleDateString()).getTime() +
                      24 * 60 * 60 * 1000 -
                      1
                  );
                  const start = new Date(
                    new Date(new Date().toLocaleDateString()).getTime()
                  );
                  return [start, end];
                },
              },
              {
                text: "3 days ago",
                value() {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
                  return [start, end];
                },
              },
              {
                text: "1 week ago",
                value() {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                  return [start, end];
                },
              },
              {
                text: "30 days ago",
                value() {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                  return [start, end];
                },
              },
              {
                text: "90 days ago",
                value() {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                  return [start, end];
                },
              },
            ],
        },
        loading: 'Loading...',
        sceneAlreadyExists: 'This scene already exists',
        previewImage: 'panorama is a quick preview image',
        applyToThumbnail: 'Thumbnail',
        delete: 'Delete',
        content: 'Deleting this scene will delete hotspots pointing to it in other scenes. Do you want to continue deleting?',
        captureScreen: 'Capture from the screen',
        generateScreenshots: 'Generate screenshots',
        thumbnailApply: 'The thumbnail has been successfully applied and will take effect after being saved',
        atLeastOne: 'Please keep at least one scene~',
        downloadCompleted:' Download completed!',
        fielDownloadFailed: 'File download failed!',
        limitImageSize: 'The image size is too large, please limit the image size to no more than',
        imageType: 'The image type is incorrect. Please upload images in PNG or JPG format',
        imageAspectRatio: 'Please upload the aspect ratio as',
        replaceFailed: 'Replacement failed, please try again',
        uploadFailed: 'Upload failed, please try again',
        restoreFailed: 'Restore failed',
        applySuccess: 'The application is successful and will take effect after save',
        dateCannotEmpty: "Date cannot be empty",
        全部: 'All',
        快速预览: 'Quick Preview ',
    },
    camera: {
        rotationSettings: 'Rotation settings',
        turnOnRotation: 'Turn on rotation',
        waitTime: 'Waiting time (seconds)',
        clickSettings: 'Set up',
        rotationInfoBefore: 'Are you sure to apply the current rotation state to the ',
        rotationInfoAfter: ' scenes in the current scene list and save them?',
        cameraSettings: 'Camera settings',
        recently: 'Closest: Minimum View during Scene Scaling',
        initial: 'Initial: Enter the initial field of view of the scene',
        farthest: 'Farthest: The maximum field of view when scaling the scene',
        recommended: 'Recommended settings: Recent 70, initial 95, farthest 125',
        viewingAngle: 'Viewing Angle',
        recentlyt: 'Closest ',
        initialt: 'Initial ',
        farthestt: 'Farthest ',
        viewInfoFirst: 'Are you sure to apply the current field of view ( Closest:',
        viewInfoSecend: '  ) to the ',
        viewInfoThird: ' scenes in the current scene list and save them?',
        inCommonUse: 'Staple',
        cameraSettings: 'Camera set',
        reset: 'Reset',
        stapleInfo: 'Save the current perspective range as my frequently used lens',
        commonLenses: 'Common lens',
        systemLens: 'System lens',
        restoreInfo: "Restore the initial value of the current scene's field of view range",
        restoreDefault: 'Restore default successful',
        recommendedLens: 'Successfully used the recommended lens, it will take effect after saving',
        usedLenses: 'Successfully used commonly used lenses, effective after saving',
        initialViewpoint: 'The initial viewpoint setting is successful and will take effect after saving',
        setCommonLens: 'Successfully set common lenses',
        initialPerspective: 'initial view',
    },
    hotspot: {
        addHotspots: 'Add hotspots',
        clear: 'clear',
        clearHotspots: 'Clear Hotspots',
        clearHotspotsForCurrentScene: 'Clear hotspots for the current scene',
        editHotspots: 'Edit hotspots',
        return: 'Return',
        hotspotType: 'Hotspot type',
        type: 'Type',
        hotspotList: 'Current scene hotspot list',
        noHotSpots: 'There are no hot spots in the current scene',
        all: 'All',
        navigation: 'Navigation',
        link: 'Link',
        image: 'Image',
        deleteHotspot: 'Confirm to delete this hotspot',
        style: 'Style',
        hotspotName: 'Hotspot name',
        name: 'Name',
        enterHotspotName: 'Please enter the hotspot name',
        targetPanorama: 'Target panorama',
        ok: 'Ok',
        cancel: 'Cancel',
        edit: 'Edit',
        delete: 'Delete',
        confirmDelete: 'Confirm to delete this hotspot',
        hotspotImage: 'Hotspot image',
        uploadImage: 'Upload image',
        editImage: 'Edit image',
        addImage: 'Add image',
        hotspotAddress: 'Hotspot address',
        address: 'Address',
        targetUrl: 'Please enter the target URL',
        videoAddress: 'Video address',
        videoUrl: 'Please enter the video URL',
        targetNoEmpty: 'The target scene cannot be empty',
        noTarget: 'There are currently no target scenarios available',
        hotspotNameNoEmpty: 'The hotspot name cannot be empty',
        hotspotDetailNoEmpty: 'Hotspot details cannot be empty',
        linkNoEmpty: 'Link address cannot be empty',
        linkIncorrect: 'The link address format is incorrect',
        videoNoEmpty: 'The video link address cannot be empty',
        pleaseUploadImage: 'Please upload the hot topic image first',
        limitImage: 'The image size is too large, please limit the image size to no more than 30M',
        uploadFailed: 'Upload failed',
        uploadSuccessful: 'Upload successful',
        imageType: 'The image type is incorrect. Please upload images in PNG or JPG format',
        text: 'Text',
        video: 'Video',
        hotspotDetail: 'Hotspot detail',
        detail: 'Detail',
        noOtherScene: 'There are currently no other scenes available',
        enterHotspotDetail: 'Please enter hotspot details',
        videoResources: 'Video resources',
        clickToSwitch: 'Click to switch',
        clickUploadVideo: 'Click to upload video',
        videoFormat: 'Supports MP4 format, maximum not exceeding 100MB',
        enerVideoUrl: 'Please enter the video URL',
    },
    music: {
        musicSettings: 'Music settings',
        trialListening: 'Trial listening',
        stopListening: 'Stop listening',
        setMusic: 'Set music',
        backgroundMusic: 'Background music',
        SystemMusicLibrary: 'System music library',
        selected: 'Selected',
        myMusic: 'My music',
        uploadMusic: 'Upload music',
        upgradePackage: 'Upgrade package',
        uploadAgree: 'Upload and agree',
        disclaimer: 'Please check the disclaimer first',
        musicName: 'Please enter the music name',
        deleteMusic: 'Delete music',
        noCustomMusic: 'No custom music',
        onlineMusic: 'Online music',
        operationProcess: 'Operation process',
        oneStep: 'Find the correct audio link, enter the audio link in the browser input bar, and if it can be played or downloaded, it is usually the correct audio link;',
        twoStep: 'Paste the audio link into the input field above;',
        threeStep: 'Click the confirm button first, and then click save in the upper left corner.',
        ok: 'Ok',
        placeholderInfo: 'Enter online music address and ensure music availability',
        musicAddress: 'Please enter the music address',
        limitMusic: 'The music address is too long. Please limit the address length to no more than 150 characters',
        saveMusic: 'Please select music before saving',
        linkIncorrect: 'The link address format is incorrect',
        musicNonEmpty: 'The music name cannot be empty',
        eidtFailed: 'edit Failed',
        deleteSuccess: 'Delete successfully',
        deleteFailed: 'Delete failed',
        limitNameCharacter: 'The file name exceeds 50 characters. Please modify it before uploading',
        limitFileSize: 'The file is too large, please limit the file size to no more than 10M',
        limitFileType: 'File format error, please upload MP3 or WAV format file',
        limitFileNumber: 'Too many files, limit upload to a maximum of 30 files',
        uploadFailed: 'Upload failed',
        uploadSuccessful: 'Upload successful',
        disclaimerInfo: 'Disclaimer',
    },
    design: {
        designerInfo: 'Designer Information Settings',
        name: 'Name',
        enterName: 'Enter Name',
        phone: 'Phone',
        enterPhone: 'Enter phone',
        avater: 'Avater',
        uploadImageInfo: 'Click to upload the image, recommended size is (64 * 64)',
        nameNonEmpty: 'Name cannot be empty!',
        phoneNonEmpty: 'Phone cannot be empty!',
        phoneNumber: 'Please enter the correct phone number!',
        limitImage: 'The image size is too large, please limit the image size to no more than 4M',
        imageType: 'The image type is incorrect. Please upload images in PNG or JPG format',
    },
    beauty: {
        filterSet: 'Filter settings',
        colorSet: 'Color settings',
        brightness: 'Brightness',
        contrastRatio: 'Contrast ratio',
        saturation: 'Saturation',
        hue: 'Hue',
        restoreDefault: 'Restore Default',
        compareOriginalImage: 'Compare the original image',
        originalImage: 'Original image',
        noFilter: 'No filter',
        warmYellow: 'yellow',
        romanticPurple: 'purple',
        modernGrey: 'grey',
        restoreSuccessful: 'Restore default successful',
    },
    tipInfo: {
        tip: 'Tip',
        switchNavigation: 'switch navigation',
        save: 'Save',
        fillCorrectly: 'Please fill in correctly ',
        panoramaEditor: 'Panorama Editor',
        editSave: 'Please edit before saving',
        viewSave: 'You still have unsaved information. Please save it before viewing it',
        saveView: 'Save view',
        save: 'saveing',
        saveSuccess: 'Saved successfully',
        请填写必填项后再进行编辑: 'Please fill in the required fields before editing',
    },
    loading: {
      schemeLoading: 'Scheme loading...',
      loadingTitle: 'Committed to becoming the best integrated home design platform',
      loadingStrives: 'Ihomecloud Technology strives to build',
    },
    driver: {
      案例详情: 'Case details',
      修改全景名称描述等: 'Modify the name and description of the panorama, set the expiration time of the panorama, and control the display of the brand logo.',
      下一步: 'Next step',
      上一步: 'Previous step',
      关闭: 'Close',
      完成: 'Complete',
      全景列表: 'Panorama list',
      增加删除修改场景: 'Add, delete and modify scenes, download panorama pictures, replace panorama thumbnails, modify panorama names.',
      视角设置 : 'Camera',
      设置全景是否开启自动旋转: 'Set whether automatic rotation is enabled for panorama; Information about the initial perspective of the panorama.',
      热点设置 : 'Hotspot settings',
      增加新的热点或修改已有热点: 'Add new hotspots or modify existing hotspots.',
      设置音乐: 'Music settings',
      设计师信息设置: 'Designer Information Settings',
      设置设计师头像姓名: 'Set designer profile picture, name, contact information, and other related information.',
      美化设置: 'Beautify settings',
      设置全景滤镜效果: 'Set the panoramic filter effect; Modify the brightness, contrast, and color equality of panoramic colors.'
    },
    video: {
      视频转换: 'Video conversion',
      上传视频: 'Upload video',
      视频格式错误请重新上传视频将转码转码时无法使用全景其他功能: 'Video format error, please upload again. The video will be transcoded, and other functions of panorama cannot be used during transcoding.',
      支持MP4格式最大不超过300M: 'Support MP4 format, up to 300M',
      上传视频编码错误请重新上传: 'Upload video encoding error, please upload again',
      视频转换中: 'Video conversion in progress'
    }
  }



// WEBPACK FOOTER //
// ./src/i18n/lan/en.js